import { render } from "./AlternativeEditorDialog.vue?vue&type=template&id=4568cc5e&ts=true"
import script from "./AlternativeEditorDialog.vue?vue&type=script&lang=ts"
export * from "./AlternativeEditorDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__